'use strict';

exports.__esModule = true;
exports['default'] = handleRenderError;
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _validators = require('react-decoration/lib/utils/validators');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    'default': obj
  };
}
function handleRenderError(UserHandler) {
  return function (Target) {
    (0, _validators.validateClass)(Target, 'handleRenderError');
    var userRender = Target.prototype.render;
    var handler = function handler(ex) {
      return _react2['default'].createElement('div', null, ex.message);
    };
    if (typeof UserHandler === 'string') {
      handler = function handler() {
        return _react2['default'].createElement('div', null, UserHandler);
      };
    } else if (typeof UserHandler === 'function' && UserHandler.prototype && UserHandler.prototype.isReactComponent) {
      handler = function handler(ex) {
        return _react2['default'].createElement(UserHandler, {
          error: ex
        });
      };
    } else if (typeof UserHandler === 'function') {
      handler = UserHandler;
    }

    // eslint-disable-next-line
    Target.prototype.render = function () {
      var result = null;
      try {
        result = userRender().apply(this);
      } catch (ex) {
        result = handler(ex);
      }
      return result;
    };
  };
}